export default __webpack_public_path__ + "static/media/360.c30523c2.png";